import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTheme } from '../../utils/useTheme';
export const AlertTipIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => {
  const $ = _c(11);
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.tokens.background.semantic.success.main.default) {
    t0 = <path d="M0 6.69087C0 2.9956 2.99561 0 6.69087 0H9.30913C13.0044 0 16 2.99561 16 6.69087V9.30913C16 13.0044 13.0044 16 9.30912 16H6.69087C2.9956 16 0 13.0044 0 9.30912V6.69087Z" fill={theme.tokens.background.semantic.success.main.default} />;
    $[0] = theme.tokens.background.semantic.success.main.default;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] !== theme.tokens.foreground.main.staticWhite) {
    t1 = <path d="M7.71859 9.02676V8.37245C7.71859 8.09631 7.94628 7.87905 8.21278 7.8067C8.38899 7.75885 8.55731 7.68544 8.71143 7.58827C9.00531 7.40299 9.23436 7.13964 9.36962 6.83152C9.50488 6.5234 9.54027 6.18436 9.47132 5.85726C9.40236 5.53016 9.23216 5.22971 8.98224 4.99389C8.73231 4.75806 8.41388 4.59746 8.06723 4.5324C7.72057 4.46734 7.36125 4.50073 7.0347 4.62836C6.70816 4.75598 6.42906 4.97211 6.23269 5.24941C6.03633 5.52671 6 5.85726 6 5.85726" stroke={theme.tokens.foreground.main.staticWhite} strokeWidth="1.5" strokeLinecap="round" />;
    t2 = <ellipse cx="7.75261" cy="11.5789" rx="0.97624" ry="0.921152" fill={theme.tokens.foreground.main.staticWhite} />;
    $[2] = theme.tokens.foreground.main.staticWhite;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== ref || $[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}{t2}</svg>;
    $[5] = props;
    $[6] = ref;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
export default AlertTipIcon;